import { render, staticRenderFns } from "./ClinicNewCampaign.vue?vue&type=template&id=0d38ee6a&scoped=true"
import script from "./ClinicNewCampaign.vue?vue&type=script&lang=js"
export * from "./ClinicNewCampaign.vue?vue&type=script&lang=js"
import style0 from "./ClinicNewCampaign.vue?vue&type=style&index=0&id=0d38ee6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d38ee6a",
  null
  
)

export default component.exports